/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SummarySections_change$ref: FragmentReference;
declare export opaque type SummarySections_change$fragmentType: SummarySections_change$ref;
export type SummarySections_change = {|
  +summary: ?{|
    +title: string,
    +sections: $ReadOnlyArray<any>,
  |},
  +$refType: SummarySections_change$ref,
|};
export type SummarySections_change$data = SummarySections_change;
export type SummarySections_change$key = {
  +$data?: SummarySections_change$data,
  +$fragmentRefs: SummarySections_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SummarySections_change",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ChangeSummary",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sections",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
// prettier-ignore
(node/*: any*/).hash = 'b90ba402f7673a4fac07f582c40f1bfc';

module.exports = node;
